import React from "react";

const Synchronize = ({ color }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="17"
      height="17"
      viewBox="0 0 17 17"
      fill="none"
    >
      <path
        d="M3.66032 4.40152H12.7616V5.9422C12.7616 6.32952 13.253 6.51888 13.5352 6.24345L16.0744 3.84206C16.2564 3.66991 16.2564 3.40309 16.0744 3.23095L13.5352 0.829553C13.253 0.562732 12.7616 0.752089 12.7616 1.13941V2.68009H2.75019C2.24962 2.68009 1.84007 3.06741 1.84007 3.54081V6.98367C1.84007 7.45702 2.24962 7.84435 2.75019 7.84435C3.25076 7.84435 3.66032 7.45702 3.66032 6.98367V4.40152ZM12.7616 13.0086H3.66032V11.468C3.66032 11.0806 3.16885 10.8913 2.88671 11.1667L0.347457 13.5681C0.165431 13.7402 0.165431 14.0071 0.347457 14.1792L2.88671 16.5806C3.16885 16.8474 3.66032 16.6581 3.66032 16.2707V14.7301H13.6717C14.1723 14.7301 14.5818 14.3427 14.5818 13.8694V10.4265C14.5818 9.9531 14.1723 9.56578 13.6717 9.56578C13.1711 9.56578 12.7616 9.9531 12.7616 10.4265V13.0086Z"
        fill={color}
      />
    </svg>
  );
};

export default Synchronize;
